import { render, staticRenderFns } from "./pwdlost-confirm.vue?vue&type=template&id=2d55852f&scoped=true&"
import script from "./pwdlost-confirm.vue?vue&type=script&lang=ts&"
export * from "./pwdlost-confirm.vue?vue&type=script&lang=ts&"
import style0 from "./main.css?vue&type=style&index=0&id=2d55852f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d55852f",
  null
  
)

export default component.exports